import { BaseApiClient } from '../BaseApiClient'

export class ApiClient extends BaseApiClient {
  static getPdfBrowserUrl(application) {
    return this.getUrl(`pdf/browser?id=${application.id}&access-token=${this.getAccessToken()}`, true)
  }

  static async getPass(applicationId, visitorId, transportId = null, isGivePassPeriod = false, printPermanentAsOne = false) {
    const data = {
      applicationId: applicationId,
      visitorId: visitorId,
      transportId: transportId,
      isGivePassPeriod: isGivePassPeriod,
      printPermanentAsOne: printPermanentAsOne
    }

    return this.post('pdf/pass', data, {
      headers: this.getAuthHeaders(),
      responseType: 'blob'
    })
  }

  static async getPasses(applicationId, isGivePassPeriod = false, printPermanentAsOne = false) {
    const data = {
      applicationId: applicationId,
      isGivePassPeriod: isGivePassPeriod,
      printPermanentAsOne: printPermanentAsOne
    }

    return this.post('pdf/passes', data, {
      headers: this.getAuthHeaders(),
      responseType: 'blob'
    })
  }

  static getBulletinUrl() {
    return this.getUrl('pdf/app-bulletin', true)
  }

  static getApplicationScreenUrl(search = null) {
    const path = search ? `vue/application/list?search=${search}` : 'vue/application/list?'

    return this.getUrl(path, true)
  }

  static getApplicationArchiveUrl(search = null) {
    const path = search ? `vue/application/list?archived=1&search=${search}` : 'vue/application/list?archived=1'

    return this.getUrl(path, true)
  }

  static getAdminPanelScreenUrl() {
    return this.getUrl('backend/black-list', true)
  }

  static getUsersScreenUrl() {
    return this.getUrl('backend/user', true)
  }

  static login(data) {
    return this.post('auth/login', data)
  }

  static loginNoPassword(data) {
    return this.post('auth/login/no-password', data)
  }

  static acceptLogin(data) {
    return this.post('auth/login/accept', data)
  }

  static async logout() {
    await this.backendLogout()

    return this.get('auth/logout', {
      headers: this.getAuthHeaders()
    })
  }

  static userMe() {
    return this.get('user/me', {
      headers: this.getAuthHeaders()
    })
  }

  static userPermissions() {
    return this.get('user/permissions', {
      headers: this.getAuthHeaders()
    })
  }

  static checkAccess() {
    return this.get('user/check-access', {
      headers: this.getAuthHeaders()
    })
  }

  static checkCurrentVisitorApplications(data) {
    return this.post('application-services/check-current-visitor-applications', data, {
      headers: this.getAuthHeaders()
    })
  }

  static checkBlacklist(personalId) {
    const data = {
      personal_id: personalId
    }

    return this.post('application-services/check-blacklist', data, {
      headers: this.getAuthHeaders()
    })
  }

  static async checkBlacklistVisitors(personalId) {
    const data = {
      personal_id: personalId
    }

    return this.post('application-services/check-blacklist-visitors', data, {
      headers: this.getAuthHeaders()
    })
  }

  static checkBlacklistByApplications(applicationIds) {
    const data = {
      application_ids: applicationIds
    }

    return this.post('application-services/check-blacklist-by-applications', data, {
      headers: this.getAuthHeaders()
    })
  }

  static removeUploadedDocument(data) {
    return this.post('upload/remove', data, {
      headers: this.getAuthHeaders()
    })
  }

  static getUploadDocuments(params) {
    return this.get('upload/get-docs', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static getTransportDocuments(params) {
    return this.get('upload/get-transports-docs', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static getApplicationDocuments(params) {
    return this.get('upload/get-application-docs', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static getLatestApplicationOrganizationDoc(params) {
    return this.get('upload/get-latest-application-organization-doc', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static createApplication(data) {
    return this.post('application-services/create-application', data, {
      headers: this.getAuthHeaders()
    })
  }

  static editApplication(data) {
    return this.post('application-services/edit-application', data, {
      headers: this.getAuthHeaders()
    })
  }

  static approveApplication(data) {
    return this.post('application-services/approve-application', data, {
      headers: this.getAuthHeaders()
    })
  }

  static changeVisitorAccess(data) {
    return this.post('visitors/change-access', data, {
      headers: this.getAuthHeaders()
    })
  }

  static changeTransportAccess(data) {
    return this.post('visitors/change-transport-access', data, {
      headers: this.getAuthHeaders()
    })
  }

  static importVisitorsFromFile(formData) {
    return this.post('application-services/import-visitors-from-file', formData, {
      headers: this.getAuthHeaders()
    })
  }

  static applicationData(params) {
    return this.get('application-data', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static vesselsData(params) {
    return this.get('vessels-data', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static configurationData(params) {
    return this.get('configuration-data', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static cfgMenuData(params) {
    return this.get('cfg-menu', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static cfgMenuDataApplicationMenu(params) {
    return this.get('cfg-menu/menu', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static deleteApplication(id) {
    return this.delete('application/delete', {
      data: { id },
      headers: this.getAuthHeaders()
    }).then(response => response.data)
  }

  static nationalityMaskData(params) {
    return this.get('nationality-document-mask-data', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static transportPlateMaskData(params) {
    return this.get('transport-plate-mask-data', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static extraApplicationData(params) {
    return this.get('application-data/extra-data', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async allowedTerminals (params) {
    return this.get('terminal/allowed-terminals', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static async allowedTerminalSectors (params) {
    return this.get('terminal-sector/allowed-sectors', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static changeFlagByVesselName(params) {
    return this.post('application-data/change-flag-by-vessel-name', params, {
      headers: this.getAuthHeaders()
    })
  }

  static otherData(params) {
    return this.get('other-data', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static issuePass(params) {
    return this.post('pass/give-pass', params, {
      headers: this.getAuthHeaders()
    })
  }

  static async getIssuedPassList(params) {
    return this.get('pass/issued-list', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static mainHeaderData(params) {
    return this.get('other-data/main-header', {
      params,
      headers: this.getAuthHeaders()
    })
  }

  static identificationPlaces(code) {
    return this.get('application-data/visitor-code', {
      params: {
        code
      },
      headers: this.getAuthHeaders()
    })
  }

  static validateTransportNumber(number) {
    const data = { number }

    return this.post('application-services/validate-transport-number', data, {
      headers: this.getAuthHeaders()
    })
  }

  static checkOrganizationInn(data) {
    return this.post('application-services/check-organization-inn', data, {
      headers: this.getAuthHeaders()
    })
  }

  static sendSupport(data) {
    return this.post('user-services/support', data, {
      headers: this.getAuthHeaders()
    })
  }

  static updateStatus(applicationId, data) {
    return this.post(`application-status/update?id=${applicationId}`, data, {
      headers: this.getAuthHeaders()
    })
  }

  static getTimeOfWork() {
    return this.get('application-data/time-of-work', {
      headers: this.getAuthHeaders()
    })
  }

  static getTerminalOrganization() {
    return this.get('organization-data/terminal-organization', {
      headers: ApiClient.getAuthHeaders()
    })
  }

  static getSignerStepOneUrl(application) {
    return this.getUrl(`application/step-one?id=${application.id}&access-token=${this.getAccessToken()}`)
  }

  static getSignerStepTwoUrl(application) {
    return this.getUrl(`application/step-two?id=${application.id}&access-token=${this.getAccessToken()}`)
  }

  static getGuardScreenUrl() {
    return this.getUrl('guard', true)
  }

  static getAccountUrl() {
    return this.getUrl('profile/account', true)
  }

  static uploadAvatar(data) {
    return this.post('upload/upload-avatar', data, {
      headers: this.getAuthHeaders()
    })
  }

  static logFrontendError(data) {
    return this.post('logger/index', data, {
      headers: this.getAuthHeaders()
    })
  }

  static sendToScud(data) {
    return this.post('xml/scud-xml', data, {
      headers: this.getAuthHeaders()
    })
  }

  static sendVisitorToSolvo(data) {
    return this.post('xml/solvo-visitor-xml', data, {
      headers: this.getAuthHeaders()
    })
  }

  static sendApplicationToScud(data) {
    return this.post('xml/application-scud-xml', data, {
      headers: this.getAuthHeaders()
    })
  }

  static documentUpdate(data) {
    return this.patch('document/update', data, {
      headers: this.getAuthHeaders()
    })
  }

  static checkNeedAttorney(data) {
    return this.post('application-services/check-need-attorney', data, {
      headers: this.getAuthHeaders()
    })
  }

  static configureApplication(data) {
    return this.post('application-services/configure', data, {
      headers: this.getAuthHeaders()
    })
  }

  static addInternalCommentRequest(data) {
    return this.post('application-services/add-internal-comment', data, {
      headers: this.getAuthHeaders()
    })
  }

  static extraData(params) {
    return this.get('pass/extra-data', {
      params,
      headers: this.getAuthHeaders()
    })
  }
}
